module.exports = __webpack_public_path__ + "static/arts@large-e6a1cd54196bc22430242fb25fba1ec6.jpg";